module.exports = __webpack_public_path__ + "static/media/vaquums-life-horizontal.fadf4223.png";